import PropTypes from "prop-types"
import React, { useState } from "react"
// Formik Validation
import { Col, Form, Label, Modal, ModalBody, Row } from "reactstrap";
import { getOptionFromValueForSelectBox, getPrimaryButtonClass } from "helpers/sf_utils";
import DropdownWithStatusIcons from "./DropdownWithStatusIcons";
import { updateWhitelistedBrandsUserMapping } from "store/admin/whitelisted-brands/actions";
import { useDispatch } from "react-redux";
import { getPrimaryTextClass } from "helpers/sf_utils"

const SSOModal = ({ modalState, onCloseClick }) => {

    const [selectedBrandAdminUser, setSelectedBrandAdminUser] = useState([]);
    const [allUserMappings, setAllUserMappings] = useState([]);

    const dispatch = useDispatch();

    const handleOnClickCloseModal = () => {
        setSelectedBrandAdminUser([]);
        setAllUserMappings([]);
        onCloseClick();
    }

    const getFullName = (admin_user) => {
        return admin_user?.first_name
            ? admin_user?.first_name + " " + admin_user?.last_name
            : admin_user?.email;
    }

    const customNameAndEmailSort = (a, b) => {
        if (a.label === "None") {
            return -1; // keep "None" at the beginning
        } else if (b.label === "None") {
            return 1;
        } else {
            return a.label.localeCompare(b.label); // sort alphabetically
        }
    }

    const getBrandAdminUsersOptions = (brandId) => {
        const brand_users = modalState?.whitelisted_brands_admin_users?.find(brand => brand?.id === brandId)?.users.filter(user => user?.discarded_at == null);

        const options = [];
        brand_users?.forEach(user => {
            options.push({
                label: user?.first_name ? (user?.first_name + " " + user?.last_name + ' (' + user?.email + ')') : user?.email,
                value: user?.id,
                status: user?.status
            })
        })
        return [{ label: "None", value: null, status: '' }, ...options].sort(customNameAndEmailSort)
    }

    const onClickUpdateUserMapping = (selectedOption, index) => {
        const data = {
            admin_user_id: modalState?.admin_user?.id,
            whitelabeled_brand_admin_user_id: selectedOption?.value,
            white_listing_brand_id: modalState?.whitelisted_brands[index]?.id,
        }
        setAllUserMappings([...allUserMappings, data])
    }

    const handleSSODetailsSubmit = (e) => {
        e.preventDefault()
        setSelectedBrandAdminUser([]);
        dispatch(updateWhitelistedBrandsUserMapping({ all_user_mappings: allUserMappings }))
        setAllUserMappings([])
        onCloseClick();
    }

    return (
        <Modal size="md" isOpen={modalState?.active} toggle={handleOnClickCloseModal} centered={true}>
            <div className="modal-body" style={{ overflowY: "hidden" }}>
                <span className="modal-title mt-0 d-flex" id="myModalLabel">
                    <i className={`${getPrimaryTextClass()} fs-17 bx bx-diamond me-1`} />
                    <span>
                        <h5 className="text-black">
                            Activate SSO
                        </h5>
                    </span>
                </span>

                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={handleOnClickCloseModal}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <ModalBody style={{ overflowY: "hidden", paddingTop: '0px' }}>
                <Form>
                    <Row>
                        <h5 className="text-black mb-3 mt-0">
                            {getFullName(modalState?.admin_user)}
                        </h5>
                        {
                            modalState?.whitelisted_brands?.map((brand, index) => {
                                const selectedUser = selectedBrandAdminUser[index] ||
                                    getOptionFromValueForSelectBox(
                                        getBrandAdminUsersOptions(brand?.id), modalState?.userMappings?.find(mapping => mapping?.white_listing_brand_id === brand?.id)?.whitelabeled_brand_admin_user_id)
                                return (
                                    <Col md={12} className="mb-3">
                                        {
                                            selectedUser && selectedUser?.status === 'active' ? <i className='mdi mdi-circle font-size-10 sfgreen me-2' /> : <i className='mdi mdi-circle font-size-10 sfred me-2' />
                                        }
                                        <Label className="font-weight-semibold">{brand?.name} <small className='text-warning'>{selectedUser && selectedUser?.status !== 'active' && selectedUser?.status !== '' && "(The selected user is not active.)"}</small></Label>
                                        <DropdownWithStatusIcons
                                            options={getBrandAdminUsersOptions(brand?.id)}
                                            onChange={(selectedOption) => {
                                                const newBrandAdminUser = [...selectedBrandAdminUser];
                                                newBrandAdminUser[index] = selectedOption;
                                                setSelectedBrandAdminUser(newBrandAdminUser);
                                                onClickUpdateUserMapping(selectedOption, index);
                                            }}
                                            value={selectedUser}
                                        />

                                    </Col>
                                )
                            })
                        }
                        <Col md={12}>
                            <div className="mt-3 mb-3 d-flex align-items-start">
                                <button
                                    type="button"
                                    name="submit"
                                    className={`btn ${getPrimaryButtonClass()}`}
                                    onClick={handleSSODetailsSubmit}
                                >
                                    Save
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-light ms-2"
                                    onClick={handleOnClickCloseModal}
                                >
                                    Cancel
                                </button>
                            </div>
                        </Col>
                    </Row>

                </Form>
            </ModalBody>
        </Modal>
    )
}

SSOModal.propTypes = {
    show: PropTypes.object,
    onClickCloseModal: PropTypes.func,
}

export default SSOModal;
